export const BLACKLANE_PARTNER_BASE = "https://partner.blacklane.com";

/** Blacklane finished trips use finished-detail; planned/active use planned-detail. */
export function isBlacklaneFinishedStatus(status?: string | null): boolean {
  if (!status) return false;
  const normalized = status.trim().toLowerCase().replace(/_/g, " ");
  return normalized === "finished" || normalized === "no show";
}

export function getBlacklanePartnerDetailUrl(
  booking: { source_id?: string | null; current_status?: string | null },
  options?: { finished?: boolean }
): string | null {
  const id = booking?.source_id;
  if (!id) return null;

  const finished =
    options?.finished ?? isBlacklaneFinishedStatus(booking.current_status);
  const segment = finished ? "finished-detail" : "planned-detail";
  return `${BLACKLANE_PARTNER_BASE}/${segment}/?id=${encodeURIComponent(String(id))}`;
}
